module.exports = __webpack_public_path__ + "img/03.61258317.png";